<template>
  <v-container class="page"
    style="max-width: 100%; padding: 0;"
  >

    <div class="flex-container">
      <div class="flex-smallitem">
        <h1
          style="text-align: center; font-size: 50px; font-weight: 400;"
        >
          DZIENNIK USTAW
        </h1>
        <h2
          style="text-align: center; text-decoration: underline; font-weight: 400; margin-bottom: 30px; font-size: 30px;"
        >
          RZECZYPOSPOLITEJ POLSKIEJ
        </h2>
        <p style="text-align: center;">Warszawa, dnia 24 sierpnia 2021 r.</p>
        <p style="text-align: center;">Poz. 1548</p>
        <p style="text-align: center; margin-bottom: 0px; font-weight: 600;">ROZPORZĄDZENIE</p>
        <p style="text-align: center; font-weight: 600;">MINISTRA EDUKACJI I NAUKI</p>
        <p style="text-align: center; font-size: 12px;">z dnia 22 lipca 2021 r.</p>
        <p style="text-align: center; font-weight: 600; font-size: 12px;">zmieniające rozporządzenie w sprawie wypoczynku dzieci i młodzieży</p>
        <p style="font-size: 12px;">Na podstawie art. 92t ustawy z dnia 7 września 1991 r. o systemie oświaty (Dz. U. z 2020 r. poz. 1327 oraz z 2021 r.poz. 4 i 1237) zarządza się, co następuje:</p>
        <p style="font-size: 12px;">§	<strong>1.</strong> W rozporządzeniu Ministra Edukacji Narodowej z dnia 30 marca 2016 r. w sprawie wypoczynku dzieci i młodzieży (Dz. U. poz. 452) załącznik nr 6 do rozporządzenia otrzymuje brzmienie określone w załączniku do niniejszego rozporzą-dzenia.</p>
        <p style="font-size: 12px;">§	<strong>2.</strong> Rozporządzenie wchodzi w życie po upływie 14 dni od dnia ogłoszenia.</p>
        <p style="text-align: right; font-size: 12px;">Minister Edukacji i Nauki: <span style="font-style: italic;">P. Czarnek</span></p>

        <div style="margin-top: 150px;">
          <hr style="border: 1px solid black; width: 150px;"/>
          <ol style="padding-top: 5px;" class="adnotation-list">
            <li style="font-size: 10px;" class="adnotation-item">
              Minister Edukacji i Nauki kieruje działem administracji rządowej – oświata i wychowanie, na podstawie § 1 ust. 2 pkt 1 rozporządze-nia Prezesa Rady Ministrów z dnia 20 października 2020 r. w sprawie szczegółowego zakresu działania Ministra Edukacji i Nauki (Dz. U. poz. 1848 i 2335).
            </li>
          </ol>
        </div>
        
      </div>

      <div class="flex-bigitem">
            <!-- <div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
          <div class="left-cointainer">
            <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg" />
          </div>
       </div> -->

        <h3 style="text-align: center; font-weight: 600; margin-bottom: 10px;">KARTA KWALIFIKACYJNA UCZESTNIKA WYPOCZYNKU</h3>

        <h4 style="margin-bottom: 20px;">I. INFORMACJE DOTYCZĄCE WYPOCZYNKU</h4>

        <ol style="padding-left: 14px;">
          <li style="margin-bottom: 10px;">
            Forma wypoczynku <span style="font-size: 9px; position: relative; bottom: 5px; right: 3px;">1)</span>
            <ul style="list-style-type: none; padding-left: 0px; padding-top: 10px;">
              <li><input type="checkbox" /> kolonia</li>
              <li><input type="checkbox" /> zimowisko</li>
              <li><input type="checkbox" checked/> obóz</li>
              <li><input type="checkbox" /> biwak</li>
              <li><input type="checkbox" /> półkolonia</li>
              <li><input type="checkbox" /> inna forma wypoczynku: .........................</li>
              <li style="margin-left: 150px;">(proszę podać formę)</li>
            </ul>
          </li>
          <li style="padding-bottom: 5px;">Termin wypoczynku: {{ termin }}</li>

          <li>
            Adres wypoczynku, miejsce lokalizacji wypoczynku:
          </li>
        </ol>
            <p style="margin-bottom: 0px; padding-left: 10px;">{{ osrodekCampu }}</p>
            <p style="margin-bottom: 0px; padding-left: 10px;">{{ adresCampu }}</p>
            Trasa wypoczynku o charakterze wędrownym<span style="font-size: 9px; position: relative; bottom: 5px;">2)</span>
            <p style="margin-bottom: 0px;">
            .........................................................................................................................................
          </p>
          <p style="margin-bottom: 0px;">
            .........................................................................................................................................
          </p>
            <p>Nazwa kraju w przypadku wypoczynku organizowanego za granicą: .........................................................................................................................................</p>
          <div class="flex-container" style="margin-top: 5px;">
            <div class="flex-item">
              Łódź, {{ aktualnaData() }}
            </div>
            <div class="flex-item">
              ......................................................................
            </div>
          </div>
          <div class="flex-container" style="margin-top: 5px;">
            <div class="flex-item" style="margin-right: 28px;">
              (miejscowość, data)
            </div>
            <div class="flex-item" style="margin-right: 15px;">
              (podpis organizatora wypoczynku)
            </div>
          </div>
        
        <hr style="border: 2px solid black; margin-top: 10px;"/>
        <h4>II. Informacje dotyczące uczestnika wypoczynku</h4>

        <ol style="padding-left: 15px;">
          <li>Imię (imiona) i nazwisko: {{ imieNazwisko }}</li>
          <li>Imiona i nazwiska rodziców: {{ imieNazwiskoRodzice }}</li>
          <li>Rok urodzenia: {{ dataUrodzenia }}</li>
          <li>Numer PESEL uczestnika wypoczynku
            <br>
            <div 
              v-for="(number, index) in pesel"
              v-bind:key="index"
              style="border: 1px solid black; width: 20px; height: 30px; display: inline-block;"
            >
              <span class="pesel-number">{{ number }}</span>
            </div>
          </li>
          <li>Adres zamieszkania: {{ adres }}</li>
          <li>Adres zamieszkania lub pobytu rodziców: <span style="font-size: 9px; position: relative; bottom: 5px; right: 3px;">3)</span> {{ adres }}</li>
        </ol>
      </div>
    </div>
    <div style="page-break-before: always;">
      </div>
    <div class="flex-container">
      <div class="flex-smallitem">
      <div>
        7. Numer telefonu rodziców lub numer telefonu osoby wskazanej przez pełnoletniego uczestnika wypoczynku, w czasie trwania wypoczynku  
          <p style="margin-top: 10px; margin-bottom: 10px;">{{ telefon ? telefon : '.........................................................................................................................................' }}</p>
      </div>
      <p>
        8. Informacja o specjalnych potrzebach edukacyjnych uczestnika wypoczynku, w szczególności o potrzebach wynikających z niepełnosprawności, niedostosowania społecznego lub zagrożenia niedostosowaniem społecznym
      </p>
      <p style="margin-top: 10px; margin-bottom: 10px;">{{ niepełnosprawność ? niepełnosprawność : '.........................................................................................................................................' }}</p>

      <p>
        9.	Istotne dane o stanie zdrowia uczestnika wypoczynku, rozwoju psychofizycznym i stosowanej diecie (np. na co uczestnik jest uczulony, jak znosi jazdę samochodem, czy przyjmuje stale leki i w jakich dawkach, czy nosi aparat ortodontyczny lub okulary)
      </p>
      <p style="margin-top: 10px; margin-bottom: 10px;">{{ stanZdrowia ? stanZdrowia : '.........................................................................................................................................' }}</p>

      <p>
        oraz o szczepieniach ochronnych (wraz z podaniem roku lub przedstawienie książeczki zdrowia z aktualnym wpisem szczepień):
      </p>

      <p style="margin-bottom: 5px;">tężec {{ tężec }}</p>
      <p style="margin-bottom: 5px;">błonica {{ błonica }}</p>
      <p style="margin-bottom: 5px;">inne {{ inneSzczepienia }}</p>
      
          <div class="flex-container" style="margin-top: 15px;">
            <div class="flex-item">
              {{ addDate }}
            </div>
            <div class="flex-item">
              {{ imieNazwiskoRodzice }}
            </div>
          </div>
           <div class="flex-container">
            <div class="flex-item" style="margin-left: 22px;">
              (data)
            </div>
            <div class="flex-item">
              (podpis rodziców/pełnoletniego uczestnika wypoczynku)
            </div>
          </div>

        <hr style="border: 2px solid black; margin-top: 10px;"/>
        <h4 style="margin-bottom: 5px;">III. DECYZJA ORGANIZATORA WYPOCZYNKU O ZAKWALIFIKOWANIU UCZESTNIKA WYPOCZYNKU DO UDZIAŁU W WYPOCZYNKU</h4>
        <p style="margin-bottom: 0px;">Postanawia się<span style="font-size: 9px; position: relative; bottom: 5px;">1)</span> :</p>
        <ul style="list-style-type: none; padding-left: 0px;">
          <li><input type="checkbox" checked/> zakwalifikować i skierować uczestnika na wypoczynek</li>
          <li><input type="checkbox" /> odmówić skierowania uczestnika na wypoczynek ze względu</li>
        </ul>

        <div class="flex-container" style="margin-top: 15px;">
            <div class="flex-item">
              {{ aktualnaData() }}
            </div>
            <div class="flex-item">
              .....................................................
            </div>
          </div>
        <div class="flex-container">
            <div class="flex-item" style="margin-left: 35px;">
              (data)
            </div>
            <div class="flex-item" style="margin-left: 50px;">
              (podpis organizatora wypoczynku)
            </div>
          </div>

      </div>

      <div class="flex-bigitem">
         <h4 style="margin-top: 15px;">
            IV. POTWIERDZENIE PRZEZ KIEROWNIKA WYPOCZYNKU POBYTU UCZESTNIKA WYPOCZYNKU W MIEJSCU WYPOCZYNKU
          </h4>

          <p style="margin-bottom: 0px;">Uczestnik przebywał ................................................................................................</p>
          <p style="padding-left: 217px; margin-bottom: 5px;">(adres miejsca wypoczynku)</p>
          <p>od dnia (dzień,miesiąc,rok)......................do dnia (dzień,miesiąc,rok).......................</p>

          <div class="flex-container" style="margin-top: 15px;">
            <div class="flex-item">
              ................................
            </div>
            <div class="flex-item">
              ...................................................
            </div>
          </div>
          <div class="flex-container" style="margin-top: 10px;">
            <div class="flex-item" style="margin-left: 42px;">
              (data)
            </div>
            <div class="flex-item" style="margin-left: 20px;">
              (podpis kierownika wypoczynku)
            </div>
          </div>

          <hr style="border: 2px solid black; margin-top: 10px;"/>
          <h4>
            V. INFORMACJA KIEROWNIKA WYPOCZYNKU O STANIE ZDROWIA UCZESTNIKA WYPOCZYNKU W CZASIE TRWANIA WYPOCZYNKU ORAZ O CHOROBACH PRZEBYTYCH W JEGO TRAKCIE
          </h4>

          <p style="margin-bottom: 0px;">
            .........................................................................................................................................
          </p>
          <p style="margin-bottom: 0px;">
            .........................................................................................................................................
          </p>
          <p style="margin-bottom: 0px;">
            .........................................................................................................................................
          </p>
          <p style="margin-bottom: 0px;">
            .........................................................................................................................................
          </p>

          <div class="flex-container" style="margin-top: 15px;">
            <div class="flex-item">
              .........................................
            </div>
            <div class="flex-item">
              ...................................................
            </div>
          </div>
          
          <div class="flex-container" style="margin-top: 10px;">
            <div class="flex-item" style="margin-left: 20px;">
              (miejscowość, data)
            </div>
            <div class="flex-item" style="margin-left: 20px;">
              (podpis kierownika wypoczynku)
            </div>
          </div>

          <hr style="border: 2px solid black; margin-top: 10px;"/>
          <h4>
            VI. INFORMACJA I SPOSTRZEŻENIA WYCHOWAWCY WYPOCZYNKU DOTYCZĄCE POBYTU UCZESTNIKA WYPOCZYNKU
          </h4>

          <p style="margin-bottom: 0px;">
            .........................................................................................................................................
          </p>
          <p style="margin-bottom: 0px;">
            .........................................................................................................................................
          </p>
          <p style="margin-bottom: 0px;">
            .........................................................................................................................................
          </p>
          <p style="margin-bottom: 0px;">
            .........................................................................................................................................
          </p>

          <div class="flex-container" style="margin-top: 15px;">
            <div class="flex-item">
              .........................................
            </div>
            <div class="flex-item">
              ...................................................
            </div>
          </div>
          <div class="flex-container" style="margin-top: 10px;">
            <div class="flex-item" style="margin-left: 20px;">
              (miejscowość, data)
            </div>
            <div class="flex-item" style="margin-left: 20px;">
              (podpis wychowawcy wypoczynku)
            </div>
          </div>

          <hr style="border: 1px solid black; margin-top: 20px;"/>

          <div style="margin-top: 50px;">
          <hr style="border: 1px solid black; width: 150px;"/>
          <ol style="padding-top: 5px;" class="adnotation-list">
            <li style="font-size: 11px;" class="adnotation-item">
              Właściwe zaznaczyć znakiem „X”.
            </li>
            <li style="font-size: 11px;" class="adnotation-item">
              W przypadku wypoczynku o charakterze wędrownym.
            </li>
            <li style="font-size: 11px;" class="adnotation-item">
              W przypadku uczestnika niepełnoletniego.
            </li>
          </ol>
        </div>

        </div>
    </div>
  </v-container>
</template>

<script>
import UmowaMonitoring from './UmowaMonitoring';

export default {
  name: 'UmowaGitara',
  components: {
    UmowaMonitoring
  },
  props: {},
  data () {
    return {
      termin: '',
      adresWypoczynku: '',
      imieNazwisko: '',
      imieNazwiskoRodzice: '',
      dataUrodzenia: '',
      adres: '',
      telefon: '',
      niepełnosprawność: '',
      stanZdrowia: '',
      szczepienia: '',
      tężec: '',
      błonica: '',
      inneSzczepienia: '',
      addDate: '',
      pesel: '',
      osrodekCampu: '',
      adresCampu: '',
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(([key, value]) => {
      this[key] = value
    })
    this.campAddress();
  },
  methods: {
    aktualnaData() {
      const today = new Date();
      let month = today.getMonth() + 1;
      if ((today.getMonth() + 1) < 10) {
        month = '0' + month
      } 
      const todayDate = today.getDate()+'-'+month+'-'+today.getFullYear()+' r.'
      return todayDate
    },
    campAddress() {
      console.log(this.termin.substring(0, 18))
      this.termin = this.termin.substring(0, 18) + ', ' + this.termin.substring(19, 37)
      const obozy = this.adresWypoczynku.split(')');
      for (let i = 0; i <= obozy.length - 2; i++) {
      if (obozy[i].includes('Bęsia')) {
        this.adresCampu += ' Bęsia 21, 11-311 Kolno,';
      } else if (obozy[i].includes('Żabinka')) {
        this.osrodekCampu += ` Ośrodek Wypoczynkowy "Żabinka,"`;
        this.adresCampu += ' Żabinka 24, 11-612 Żabinka,';
      } else if (obozy[i].includes('Panorama')) {
        this.osrodekCampu += ` Dom Wypoczynkowy Panorama,`;
        this.adresCampu += ' Małe Ciche 32a, Murzasichle 34-531,';
      } else if (obozy[i].includes('U Elżbiety')) {
        this.osrodekCampu += ` Pokoje Gościnne " U Elżbiety,"`;
        this.adresCampu += ' Małe Ciche 52, 34-531,';
      } else if (obozy[i].includes('Tarasówka')) {
        this.osrodekCampu += ` Pokoje Gościnna "Tarasówka",`;
        this.adresCampu += ' Małe Ciche 5a Murzasichle 34-531,';
      } else if (obozy[i].includes('Rafa')) {
        this.osrodekCampu += ` Ośrodek kolonijno-Wczasowy Rafa,`;
        this.adresCampu += ' Nadmorska 1, 76-107 Jarosławiec,';
      }
    }
  },
  },
  mounted() {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href;
          history.replaceState(history.state, "", "/");
          window.print();
          history.replaceState(history.state, "", currentURL);
        }, 300);
      });
  }
}
</script>

<style scoped>
.page-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: nowrap;
}
.flex-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    flex-wrap: nowrap;
    column-gap: 20px;
}
.flex-bigitem {
  flex-grow: 1;
  width: 50%;
}
.flex-smallitem {
  flex-grow: 1;
  width: 50%;
}
.row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}
#header {
    text-transform: uppercase;
    text-decoration: underline;
    margin-bottom: 20px;
    text-align: center;
}
h4 {
    text-transform: uppercase;
}
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
  margin: 0px;
}
table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
}
th, td {
  border: 1px;
  border-collapse: collapse;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}
ul.dashed {
  list-style-type: "-";
  margin: 0;
}
.underline {
  text-decoration: underline;
}
.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}
.adnotation-list {
  counter-reset: list;
  padding-left: 0px;
}
.adnotation-item {
  list-style: none;
}
.adnotation-item:before {
  content: counter(list) ") ";
  counter-increment: list;
}
.pesel-number {
  font-size: 16px;
  font-weight: 600;
  position: relative;
  top: 3px;
  left: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/KartaKwalifikacyjnaKolonie.vue